<template>
  <Title>{{`${productData?.nameEn || companyName} - Printed with your logo | Customized by ${companyName}`}}</Title>
  <Meta name="description" :content="productData?.descriptionEn" />
  <Meta name="keywords" :content="productData?.keyWord" />
  <div v-if="!show404">
    <div v-if="info.shelfStatus === 1">
      <div class="d-flex justify-center sold-out">
        <div class="img-wrap">
          <img :src="info.imgMainUrl" />
        </div>
        <div class="ml-5">
          <div>
            <p class="fb-650 fs-18">{{ info.nameEn }}</p>
            <p class="fc-blue fs-14"># {{ info.code }}</p>
          </div>
          <div class="text fs-14 px-8 mt-3">
            The product you were browsing is currently sold out.
          </div>
          <v-btn
            @click="navigateTo('/')"
            class="mt-8 btn-sty"
            variant="outlined"
            color="#2196F3"
            >Return to the homepage</v-btn
          >
        </div>
      </div>
    </div>
    <div v-else class="py-5 pl-2 pr-2 sp-container">
      <v-row no-gutters class="d-flex justify-center">
        <v-col cols="12">
          <v-row>
            <v-col
              cols="12"
              xs="12"
              sm="12"
              md="12"
              lg="6"
              xl="6"
              xxl="6"
              class="pb-0 pa-2 pl-3"
            >
              <div
                class="nav fc-888 fs-14 scroller d-flex align-center justify-space-between pb-0"
              >
                <ul class="d-flex" style="line-height: 16px">
                  <li>
                    <span>All Products&nbsp;&nbsp;/</span>
                  </li>
                  <li v-if="categorys?.length > 1">
                    <span class="pointer" @click="jumpCategory(categorys[0])"
                      >{{ categorys[0]?.nameEn }}&nbsp;&nbsp;/</span
                    >
                  </li>
                  <li class="nav-catalog">
                    <span
                      class="pointer"
                      @click="
                        jumpCategory(categorys[categorys?.length > 1 ? 1 : 0])
                      "
                      >{{
                        categorys[categorys?.length > 1 ? 1 : 0]?.nameEn
                      }}</span
                    >
                  </li>
                </ul>
                <div
                  v-if="info.calcFreight || isFreeSample"
                  class="d-none d-sm-block d-lg-none product-tags"
                >
                  <img
                    v-if="info.calcFreight"
                    :width="140"
                    aspect-ratio="16/9"
                    cover
                    :src="freeShipping"
                  />
                  <img
                    v-if="isFreeSample"
                    :width="130"
                    aspect-ratio="16/9"
                    cover
                    :src="freeSample"
                  />
                </div>
              </div>
            </v-col>
            <v-col
              v-if="info.calcFreight || isFreeSample"
              cols="12"
              xs="12"
              sm="12"
              md="12"
              lg="6"
              xl="6"
              xxl="6"
              class="pb-0 d-block d-sm-none d-lg-block pa-2 pl-3"
            >
              <div class="product-tags">
                <img
                  v-if="info.calcFreight"
                  :width="140"
                  aspect-ratio="16/9"
                  cover
                  :src="freeShipping"
                />
                <img
                  v-if="isFreeSample"
                  :width="130"
                  aspect-ratio="16/9"
                  cover
                  :src="freeSample"
                />
              </div>
            </v-col>
          </v-row>

          <client-only>
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6" xxl="6">
                <img-carousel
                  ref="carouselRef"
                  :files="carouselFiles"
                  :youTubeId="youTubeId"
                  @openImgPpt="showImgppt = true"
                  @change-current-index="currentImgIndex = $event"
                />
                <div class="d-none d-md-block">
                  <div
                    class="download-btns"
                    :class="{ 'has-die-drawing': dieDrawingImgs.length }"
                  >
                    <v-btn
                      flat
                      color="blue"
                      variant="outlined"
                      :loading="downloadingAtlas"
                      @click="downloadAtlas"
                    >
                      <template v-slot:prepend>
                        <img src="~/assets/imgs/u18.svg" width="22" heigth="22" />
                      </template>
                      Download Hi-Res Image
                    </v-btn>
                    <v-btn
                      flat
                      color="blue"
                      class="ml-4"
                      variant="outlined"
                      @click="downloadTemplate"
                      v-if="dieDrawingImgs.length"
                    >
                      <template v-slot:prepend>
                        <img src="~/assets/imgs/u19.svg" width="22" heigth="22" />
                      </template>
                      Download Template
                    </v-btn>
                  </div>
                </div>
                <div class="d-none d-xs-none d-lg-block">
                  <product-describe :describe="describeInfo" />
                </div>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6" xxl="6">
                <product-content
                  :details="info"
                  :specsColor="specsColor"
                  :specsSize="specsSize"
                  :imprints="imprints"
                  :minNum="minNum"
                  :dieDrawingImgs="dieDrawingImgs"
                  @productQuantityExceedsFn="productQuantityExceedsFn"
                />
                <div class="d-lg-none pb-5">
                  <product-describe :describe="describeInfo" />
                </div>
              </v-col>
            </v-row>
          </client-only>
        </v-col>
      </v-row>
    </div>
    <div class="recommand-wrapper" v-show="info.shelfStatus != 1">
      <div class="sp-container">
        <v-row nogutters>
          <v-col cols="12" class="mt-4 pa-0" v-if="productRelateds?.length">
            <shopmall-product-carousel
              :product-list="productRelateds"
            ></shopmall-product-carousel>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
  <div v-else>
    <shopmall-404></shopmall-404>
  </div>
  <product-quantity-exceeds
    v-model="showProductQuantityExceeds"
  ></product-quantity-exceeds>
  <Teleport to="body" v-if="showImgppt && carouselFiles.length">
    <img-ppt
      :files="carouselFiles"
      :currentIndex="currentImgIndex"
      @close="showImgppt = false"
    />
  </Teleport>
  <!-- 下载刀模图弹窗 -->
  <shopmall-dialog
    ref="spDialog"
    :show-confirm="false"
    :show-cancel="false"
    title="Download Template"
    :maxWidth="520"
  >
    <div class="download-template-panel" style="max-height: 280px">
      <div
        class="download-template-item d-flex justify-space-between align-center mb-4"
        v-for="(item, index) in dieDrawingImgs"
        :key="index"
      >
        <span class="download-template-item-tit">
          {{ item.file.fileName }}
          <v-tooltip
            activator="parent"
            location="top"
            class="custom-file-tooltip"
            >{{ item.file.fileName }}</v-tooltip
          >
        </span>
        <v-btn
          flat
          variant="outlined"
          size="small"
          @click="downloadFile(item.file.path, item.file.fileName)"
          >Download</v-btn
        >
      </div>
    </div>
  </shopmall-dialog>
</template>

<script setup>
import { productInteractor, systemInteractor } from "~/core"
import imgCarousel from "~/components/product/img-carousel"
import imgPpt from "~/components/product/img-ppt.vue"
import productDescribe from "~/components/product/product-describe"
import productContent from "~/components/product/product-content"
import { useProductStore, useDesignStore, useUserStore } from "~/stores"
import { emitter } from "~/plugins/bus"
import freeShipping from "~/assets/svg/freeShipping.svg"
import freeSample from "~/assets/svg/freeSample.svg"
import JSZip from "jszip"
import { baseAxios } from "~/core/services/request"
import { downloadUrl, getFileSuffix } from "kits"
import { trackFromPage } from "~/utils/report/tracking"

const showProductQuantityExceeds = ref(false)
const productQuantityExceedsFn = () => {
  showProductQuantityExceeds.value = true
}
const productStore = useProductStore()
const {
  $Bus,
  $Utils,
  $Buryingpoint,
  $BaseClickBurying,
  $MallPageName,
  $ClickSource,
  $SetContentGroups,
  $multiPlatform,
  $Reporter
} = useNuxtApp()
const route = useRoute()
const router = useRouter()
const getCode = () => {
  const query = route.path.split("/product/")[1]
  const code = query.split("_")[0]
  return code
}
const config = useRuntimeConfig()
const companyName = $multiPlatform.companyName
const productData = ref(null)
const ssrRes = await useAsyncData(
  "mountains",
  () =>
    $fetch(
      `${
        config.public.serverBaseUrl
      }product/api/v1/product/detail/code/${getCode()}`,
      {
        headers: {
          tenantId: config.public.tenantId,
          Systemcode: "mall",
          erpTenantId: config.public.erpTenantId
        },
        method: "GET"
      }
    ),
  {}
)
productData.value = ssrRes?.data?.value?.data

const store = useUserStore()
const carouselRef = ref(null)
const info = ref({})
const categorys = ref([]) // 分类层级
const describeInfo = ref({}) // 产品描述
const carouselFiles = ref([]) // 轮播图片
const specsColor = ref({}) // 规格颜色
const specsSize = ref({}) // 规格尺寸
const imprints = ref([]) // 印刷方式
const productRelateds = ref([]) // 相关产品
const hasSpecImage = ref(true) // 是否存在规格图
const minNum = ref("") // 阶梯最小数量
const youTubeId = ref("")
const dieDrawingImgs = ref([]) //刀模图
const showImgppt = ref(false) // 是否显示大图模式
const spDialog = ref(null)
const downloadingAtlas = ref(false) //下载Hi-Res Image loading
const currentImgIndex = ref(0) // 当前大图索引
/**
 * 获取产品详情
 * @param {id} 产品id
 */
const show404 = ref(false)
const getDetails = async () => {
  let res = productData.value
  // if (!res) {
    const [data] = await productInteractor.getProductDetailByCodeApi(
      getCode()
    )
    res = data
    productData.value = res
  // }

  const designStore = useDesignStore()
  
  if (res === null) {
    show404.value = true
    return
  }
  if (res) {
    if (store?.userInfo?.status == 1) saveRecordFn(res.id)
    designStore.setPrints(res)
    productStore.setProduct({
      id: res.id,
      nameEn: res.nameEn,
      code: res.code
    })
    info.value = res
    // 刀模图图片
    let imgArr = res?.knifeFiles ?? []
    imgArr = imgArr.filter((item) => item.file)
    for (let k of imgArr) {
      k.file.path = k?.file?.path?.replace(/\?.*$/, "")
      k.file.fileName = k?.file?.name
        ? k.file.name
        : k?.file?.path?.match(/[^/]+$/)[0]
    }
    dieDrawingImgs.value = imgArr
    setCategorys(res.category)
    categorys.value = categorys.value.reverse()
    youTubeId.value = res?.youtubeId ?? ""
    describeInfo.value = getDescribeInfo(res)
    carouselFiles.value = getCarouselFiles(res)
    specsColor.value = useProduct().getSpecsColor(res)
    specsSize.value = useProduct().getSpecsSize(res)
    imprints.value = getImprints(res)
    minNum.value = res.productPricingSteps?.length
      ? res.productPricingSteps[0].num
      : ""
    getProductRelateds(res.id)
  }
}

// 保存浏览记录
const saveRecordFn = async (productId) => {
  await systemInteractor.saveRecordApi({ productId })
}

// 二级分类跳转
const jumpCategory = (item) => {
  productStore.setAccessories({
    id: item.id,
    nameEn: item.nameEn
  })

  const nameEn = $Utils.replaceSpacesWithDash(item.nameEn, false)
  navigateTo(`/category/${nameEn}`)
}

/**
 * 设置分类层级集合
 * @param {category}
 */
const setCategorys = (category) => {
  if (!category) return
  categorys.value.push({
    level: category.level,
    nameEn: category.nameEn,
    id: category.id
  })
  if (category.parent) {
    setCategorys(category.parent)
  }
}

/**
 * 获取相关产品
 * @param {id}
 */
const getProductRelateds = async (id) => {
  const [res] = await productInteractor.productRelatedApi(id)

  res && (productRelateds.value = res)
}

/**
 * 获取产品描述信息
 * @param {data}
 */
const getDescribeInfo = (data) => {
  let colorOptions = [] // 颜色
  let imprintMethod = [] // 印刷方式
  let imprintArea = [] // 印刷区域
  let productSize = [] // 产品尺寸
  let productWeight = [] // 产品重量
  let packingMethod = [] // 包装方式

  // Standard Color Options
  if (data?.specsType?.includes("Color")) {
    const specs = data.specsValue.replace(/\'/g, '"')
    let downShelfSpecsArr = data?.downShelfSpecs?.replace(/\'/g, '"') ?? "[]"
    downShelfSpecsArr = JSON.parse(downShelfSpecsArr)
    let downShelfSpecs = []
    data.specsType.split(",").find((item, i) => {
      if (item === "Color") {
        colorOptions = JSON.parse(specs)[i]
        downShelfSpecs = downShelfSpecsArr?.[i] ?? []
      }
    })

    colorOptions = colorOptions.filter((item) => !downShelfSpecs.includes(item))
  }
  // Imprint Method
  data.printingWays.forEach((item) =>
    imprintMethod.push(item.printingWayNameEn)
  )
  // Imprint Area
  data.printingSurfaces.forEach((item) => {
    let sizes = []
    item?.printingRegions?.forEach((region) =>
      sizes.push(
        item.printingPositionNameEn +
          "-" +
          region.regionName +
          "-" +
          region.regionWidth +
          "''" +
          " x " +
          region.regionHigh +
          "''"
      )
    )
    sizes = sizes.join(",")

    imprintArea.push(sizes)
  })
  // Product size/Product Weight/Packing Method
  data.productSpecs.forEach((item) => {
    let productDimensions = []

    if (item.productLengthCm !== 0) {
      productDimensions.push(
        $Utils.sizeUnitChange(item.productLengthCm, item.sizeUnit)
      )
    }

    if (item.productWidthCm !== 0) {
      productDimensions.push(
        $Utils.sizeUnitChange(item.productWidthCm, item.sizeUnit)
      )
    }

    if (item.productHeightCm !== 0) {
      productDimensions.push(
        $Utils.sizeUnitChange(item.productHeightCm, item.sizeUnit)
      )
    }

    if (productDimensions.length > 0) {
      productSize.push(productDimensions.join(" x "))
    }

    if (item.productWeightKgs) {
      // kg 转为lbs(磅)
      productWeight.push((item.productWeightKgs * 2.2046).toFixed(2))
    }
    if (item.packingMethodEn) {
      packingMethod.push(item.packingMethodEn)
    }
  })
  productSize = Array.from(new Set(productSize))
  productWeight = Array.from(new Set(productWeight))
  packingMethod = Array.from(new Set(packingMethod))

  const object = {
    descriptionEn: data.descriptionEn,
    material: data.material,
    colorOptions: colorOptions.map((item) => item.trim()).join(",&nbsp;"),
    imprintMethod: imprintMethod.join(","),
    imprintArea: imprintArea.join(","),
    productSize: productSize.join(","),
    productWeight: productWeight.join(" lbs, "),
    packingMethod: packingMethod.join(",")
  }

  return object
}

/**
 * 产品轮播图片 主图+规格图+细节图
 * @param {data}
 * @param {data.imgMainUrl} 主图
 * @param {data.productSpecs} 规格图
 * @param {data.files} 细节图
 */
const getCarouselFiles = (data) => {
  const _files = []

  // 添加主图
  _files.push({
    type: "image",
    file: data.imgMainUrl
  })

  let colorsData = useProduct().getSpecsColor(data).colors
  if (colorsData?.length) {
    _files.push({
      type: "image",
      file: colorsData[0].imageUrl
    })
  } else {
    hasSpecImage.value = false
  }
  // 添加细节图
  if (data.files.length) {
    for (let i = 0; i < data.files.length; i++) {
      if (data.files[i]?.file?.path) {
        _files.push({
          type: "image",
          file: data.files[i].file.path
        })
      }
    }
  }

  return _files
}

/**
 * 切换规格图
 * @param {image} 规格图
 */
$Bus.on("spec-image", async (image) => {
  if (hasSpecImage.value) {
    await $Utils.preloadImages(image)
    if(carouselFiles?.value[1]?.file) {
      carouselFiles.value[1].file = image
    }
    carouselRef.value && carouselRef.value.specImage(1, "spec")
  }
})

/**
 * 获取印刷方式
 * @param {data}
 */
const getImprints = (data) => {
  const imprints = []

  if (data.printingWays?.length) {
    const arr = data.printingWays.map((item) => {
      return {
        ...item,
        nameEn: showFullColor(item) ? "Full Color" : item.printingWayNameEn
      }
    })
    for (let i = 0; i < arr.length; i++) {
      imprints.push(arr[i])
    }
  }
  // 默认添加Blank
  if (data.showBlank !== 0)
    imprints.push({ printingWayNameEn: "Blank", nameEn: "Blank" })
  // proofingSupported:true 支持样品
  if (data.proofingSupported) {
    imprints.push({ printingWayNameEn: "Sample", nameEn: "Sample" })
  }

  return imprints
}

/**
 * 是否显示Full Color
 * @returns Boolean
 */
const showFullColor = (item) => {
  const method = item.pricingMethod?.split(",")

  if (method?.length === 1 && method[0].toLowerCase() === "full-color") {
    return true
  } else {
    return false
  }
}

// 清除$Bus
router.beforeEach((to, from, next) => {
  if (from.path.match("product")) {
    emitter.all.clear()
  }
  
  next()
})

// download template 相关逻辑 --------------- start
//读取txt编码之后的内容
const readFile = (filePath) => {
  // 创建一个新的xhr对象
  let xhr = null,
    okStatus = document.location.protocol === "file" ? 0 : 200
  xhr = window.XMLHttpRequest
    ? new XMLHttpRequest()
    : new ActiveXObject("Microsoft.XMLHTTP")
  xhr.open("GET", filePath, false)
  xhr.overrideMimeType("text/html;charset=utf-8")
  xhr.send(null)
  return xhr.status === okStatus ? xhr.responseText : null
}
const downloadFile = (url, name) => {
  // 下载模板事件埋点
  try {
    systemInteractor.eventRecordApi({eventName: "download_template"});
    $BaseClickBurying(
      $MallPageName.mallProductDetail,
      $ClickSource.mallProductDetailDownloadTemplate
    )
    $Reporter.click({event: 'e_product_detail_download_template'})
  } catch (err) {}
  const textPattern = /\.txt$/i
  if (textPattern.test(url)) {
    downloadTxt(url, name)
  } else {
    downloadUrl(url, name)
  }
}
const downloadTxt = (fileUrl, fileName) => {
  const element = document.createElement("a")
  element.setAttribute(
    "href",
    "data:text/plain;charset=utf-8," + encodeURIComponent(readFile(fileUrl))
  )
  element.setAttribute("download", fileName)
  element.style.display = "none"
  element.click()
}
const downloadTemplate = () => {
  if (dieDrawingImgs.value.length > 1) {
    spDialog.value && spDialog.value.show()
    return
  }

  if (dieDrawingImgs.value.length === 1) {
    downloadFile(
      dieDrawingImgs.value[0].file.path,
      dieDrawingImgs.value[0].file.fileName
    )
  }
}
// download template 相关逻辑 --------------- end

// 已zip的形式下载大图列表
const downloadAtlas = async () => {
  const zip = new JSZip()
  let n = 0
  for (let i = 0; i < carouselFiles.value.length; i++) {
    const item = carouselFiles.value[i]
    if (item.type === "image") {
      n++
      const fileName = info.value?.code + "-" + n
      const suffix = getFileSuffix(item.file)
      const { data } = await baseAxios({
        method: "get",
        url: item.file,
        responseType: "blob"
      })
      zip.file(fileName + "." + suffix, data, { binary: true })
      downloadingAtlas.value = i !== carouselFiles.value.length - 1
    }
  }

  zip.generateAsync({ type: "blob" }).then(function (content) {
    const url = URL.createObjectURL(content)
    downloadUrl(url, `${info.value?.code}.zip`)
  })

  systemInteractor.eventRecordApi({eventName: "download_hi_res_image"});

  $BaseClickBurying(
    $MallPageName?.mallProductDetail,
    $ClickSource?.mallDownloadHiResImage
  )
  $Reporter.click({event: 'e_download_hi_res_image'})
}

// 是否免费打样
const isFreeSample = computed(() => {
  return (
    info?.value?.proofingSupported &&
    info?.value?.proofingFee &&
    info?.value?.proofingFee === "0.00"
  )
})

onMounted(() => {
  nextTick(() => {
    getDetails()
  })
  trackFromPage()
  try {
    if (route.query.t === "ba") {
      $Buryingpoint.bannerProductClick(getCode())
      if(route.query.source==='banner') {
        $Buryingpoint.commonClick('home_product_click',{
          click_source:$ClickSource.mallHomeBanner
        })
        // 埋点轮播图点击事件
        $Buryingpoint.bannerClick(location.href);
      }
    }
    if (route.query.t === "history") {
      $Buryingpoint.commonClick("history_product_click", {
        produt_name: route.params?.id?.split("_")[1] || ""
      })
    }
    if (route.query.t === "ca") {
      const i = route.params?.id?.indexOf('_')
      $Buryingpoint.commonClick("category_product_click", {
        produt_name: route.params?.id?.slice(i+1) || "",
        category_name: route.query?.ca_name
      })
    }
    if (route.query.t === "ta") {
      $Buryingpoint.commonClick("theme_acivity_product_click", {
        produt_name: route.params?.id?.split("_")[1] || "",
        theme_activity_id: route.query?.businessid
      })
    }
    if (route.query.t === "ba_ta") {
      $Buryingpoint.bannerProductClick(getCode())
      $Buryingpoint.commonClick("theme_acivity_product_click", {
        produt_name: route.params?.id?.split("_")[1] || "",
        theme_activity_id: route.query?.businessid
      })
    }
    if (route.query.source === "new_home") {
      $Buryingpoint.commonClick('home_to_detail')
    }

    if (route.query.t === "ba_ca") {
      const i = route.params?.id?.indexOf('_')
      $Buryingpoint.bannerProductClick(getCode())
      $Buryingpoint.commonClick("category_product_click", {
        produt_name: route.params?.id?.slice(i+1) || "",
        category_name: route.query?.ca_name
      })
    }

    $BaseClickBurying(
      $MallPageName?.mallProductDetail,
      $ClickSource?.mallProductDetailEnter
    )
    $SetContentGroups("mall_product_details")
  } catch (err) {
    console.log(err)
  }
})
</script>

<style scoped lang="scss">
@import "@/assets/scss/product.scss";
.recommand-wrapper {
  background-color: rgba(242, 242, 242, 1);
}
.download-btns {
  padding: 10px 0 0 0;
  display: flex;
  button {
    width: 100%;
  }
  &.has-die-drawing {
    padding: 10px 20px 0 0;
    button {
      width: 50%;
    }
  }
}
.product-tags {
  img {
    display: inline-block;
    margin-left: 10px;
    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
